module.exports = __webpack_public_path__ + "media/assets/icons/angle-double-left-a1bfbb59e31ad802b805b772afa9d9e6.svg";